module.exports = __webpack_public_path__ + "media/images/top/common/img_step02-2d82f96ba6818bfb9b49893bde86b0d9.png";